import * as React from 'react';
import { connect } from 'react-redux';
import { hashHistory, RouteComponentProps, RouteProps } from 'react-router';
import { FindInitialRestaurant, SetBounced, SetRestaurantUrl } from '../../actions/Actions';
import { AppConfig, CollectionRestaurantSummary } from '../../Api';
import * as Api from '../../Api';
import { Async } from '../../Data';
import * as Store from '../../Store';
import { Utilities } from '../../Utilities';
import LoadingPanel from '../LoadingPanel';
import { routerActions } from '../../redux';
import { MainLayout } from '../MainLayout/MainLayout';

interface AppRoute
  extends RouteComponentProps<
    {
      bounceurl: string;
    },
    {},
    {}
  > {}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;

interface StateProps {
  showRestaurantList: boolean;
  Bounced: boolean;
  isDark: boolean;
  AppConfig: Async<AppConfig>;
  CollectionSummaries: Async<CollectionRestaurantSummary[]>;
  AppDesignScheme: Api.AppDesignScheme;
}

interface State {}

type Props = DispatchProps & StateProps & AppRoute;

export class App extends React.Component<Props, State> {
  public componentWillMount() {
    this.props.updateRouterState({
      pathname: this.props.location.pathname,
      params: this.props.params
    });
  }

  public componentDidMount() {
    this.props.SetBounced(true);
  }

  public UNSAFE_componentWillReceiveProps(nextProps: Props) {
    const {
      Bounced,
      showRestaurantList,
      AppConfig,
      CollectionSummaries,
      FindInitialRestaurant,
      SetRestaurantUrl
    } = nextProps;

    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.props.updateRouterState({
        pathname: nextProps.location.pathname,
        params: nextProps.params
      });
    }

    const { bounceurl } = nextProps.params;

    if (Bounced && AppConfig.status === 'success') {
      const isPwa: boolean = Utilities.extraOption('data-pwa') === 'true';

      const pwaOnMobile =
        (Utilities.isAndroid || Utilities.isIOSPhone) && Utilities.isStandalone && isPwa;

      FindInitialRestaurant((vrid: number) => {
        if (CollectionSummaries.status === 'success') {
          if (bounceurl.substring(1) === '/') {
            const lastUrl = localStorage.getItem('flipdish-last-url');
            const lastUrlExpiry = localStorage.getItem('flipdish-last-url-expiry');

            if (lastUrl && lastUrlExpiry && Date.now() < parseInt(lastUrlExpiry) && pwaOnMobile) {
              hashHistory.replace(lastUrl.substr(1));
            } else if (
              !AppConfig.data.PickupEnabled &&
              AppConfig.data.DisplayDeliveryRestaurantListScreen
            ) {
              hashHistory.replace('/delivery');
            } else if (
              !AppConfig.data.DeliveryEnabled &&
              AppConfig.data.DisplayPickupRestaurantListScreen
            ) {
              hashHistory.replace(this.collectionLink());
            } else if (!showRestaurantList) {
              const url = '/restaurant/' + vrid;
              SetRestaurantUrl(url);
              hashHistory.replace(url);
            } else {
              hashHistory.replace('/where');
            }
          } else {
            hashHistory.replace(bounceurl.substring(1));
          }
        }
      });
    }
  }

  public collectionLink(): string {
    const { AppConfig, CollectionSummaries } = this.props;

    switch (AppConfig.status) {
      case 'success':
        break;
      default:
        return '/collection';
    }

    if (AppConfig.data.DisplayPickupRestaurantListScreen) {
      return '/collection';
    }

    if (CollectionSummaries.status != 'success') {
      return '/collection';
    }

    const [skip] = CollectionSummaries.data.filter((c) => c.SkipToThisPhysicalRestaurant);

    if (!skip) {
      return '/collection';
    }

    return '/restaurant/' + skip.VirtualRestaurantId + '/collection/' + skip.PhysicalRestaurantId;
  }

  public render(): JSX.Element {
    const { AppDesignScheme, isDark } = this.props;

    return (
      <MainLayout>
        <LoadingPanel isDark={isDark} AppDesignScheme={AppDesignScheme} />
      </MainLayout>
    );
  }
}

const mapStateToProps = (s: Store.State): StateProps => {
  return {
    showRestaurantList: s.flipdish.Config.showRestaurantList,
    Bounced: s.flipdish.Bounced,
    isDark: s.flipdish.isDark,
    AppConfig: s.flipdish.AppConfig,
    CollectionSummaries: s.flipdish.CollectionSummaries,
    AppDesignScheme: s.appDesignScheme
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateRouterState: (payload: WebOrder.State.Location) => {
      dispatch(routerActions.updateRouterState(payload));
    },
    FindInitialRestaurant: (then: (vrid: number) => any): any => {
      dispatch(FindInitialRestaurant(then));
    },

    SetRestaurantUrl: (url: string) => {
      dispatch(SetRestaurantUrl(url));
    },

    SetBounced: (bounced: boolean) => {
      dispatch(SetBounced(bounced));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
